import * as cx from 'classnames';
import {
    AUTOMATIC_MESSAGE_VIOLATES_RULES,
    DELETE,
    FORUM_POST_ADD_COMMENT_AS_ANOTHER_USER,
    FORUM_POST_ADMINCLUB_MENU,
    FORUM_POST_EDIT_MENU,
    PIN_POST,
    SEND_HEART_TO_username,
    SHOW_USERS_WHO_LIKED_THIS_POST,
    UNPIN_POST,
} from 'mk/autogenerated/translations/PostMenu.4860cd0fb509319125ca08d99dff42b5'
import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { adminclub_forum_post_url, hearts_url } from 'mk/urls/functions';
import { DateRange1, KeywordFilterType } from 'mk2/apps/dash/containers/SeoPerformance/FilterForm';
import * as dashUrls from 'mk2/apps/dash/urls';
import { forumDeletePost, postSendHeart } from 'mk2/apps/forum/actions';
import PostMenuTrigger from 'mk2/apps/forum/components/PostMenuTrigger';
import { TESTINGS_TOPIC_ID } from 'mk2/apps/forum/constants';
import { postDetailPostSticky } from 'mk2/apps/forum/containers/PostDetail/PostDetail.actions';
import { POST_DETAIL_MENU_MORE } from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import { ContestEntity, PostEntity } from 'mk2/apps/forum/schemas';
import * as urls from 'mk2/apps/forum/urls';
import { isCounsellingPost } from 'mk2/apps/forum/utils';
import MenuItem from 'mk2/components/menu/MenuItem';
import { complaintInitToggle } from 'mk2/containers/Complaint/Complaint.actions';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import { AppState, getRequestPermissions, getRequestUser } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import styles from './PostMenu.mscss';

interface OwnProps {
    className?: string;
    post: PostEntity;
    contest: ContestEntity;
}

interface StateProps {
    requestUser: UserEntity;
    permissions: string[];
}

interface DispatchProps {
    onSendHeart();
    onToggleMenuMore();
    onReport(entity: string, id: number);
    onDelete(id: number);
    onChangeSticky(id: number, sticky: boolean);
}

type RouteProps = RouteComponentProps<{}>;
type Props = OwnProps & StateProps & DispatchProps & RouteProps;

class PostMenu extends React.Component<Props> {

    public render() {
        const {
            post, onToggleMenuMore, className,
            requestUser, permissions, contest,
            location, onSendHeart,
        } = this.props;

        if (!post || post.deletedAt || post.topic.deletedAt) {
            return null;
        }

        const isAdmin = permissions.indexOf('forum.can_manage_forum') !== -1;
        const isModerator = isAuthenticatedAs(requestUser, post.topic.moderators);
        const isAuthor = isAuthenticated(requestUser);

        const postTime = new Date(post.created);
        const commentTimeWithDelay = new Date((new Date (postTime)).setMinutes(postTime.getMinutes() + 2));
        const currentTime = new Date(Date.now());
        const isEditable = commentTimeWithDelay > currentTime;

        const canEdit = isAdmin || (isAuthor && isEditable);
        const isTesting = post.topic.id === TESTINGS_TOPIC_ID;
        const isCounselling = isCounsellingPost(post);
        const hasSeoStats = post && permissions.indexOf('dash.can_manage_seo') >= 0;

        return (
            <Menu
                className={cx(styles.PostMenu, className)}
                menuId={POST_DETAIL_MENU_MORE}
                trigger={<PostMenuTrigger onClick={onToggleMenuMore} />}
                triggerShadow={false}
            >
                {post && !isCounselling ?
                    <MenuItem
                        label={AUTOMATIC_MESSAGE_VIOLATES_RULES}
                        icon="fa-exclamation-triangle"
                        onClick={this.onReport}
                    /> : null
                }

                {!isCounselling &&
                    <MenuItem
                        label={interpolate(SEND_HEART_TO_username, { username: `${post.author.username}` })}
                        icon="fa-heart-o"
                        link={isAuthenticated(requestUser) ? url(hearts_url(), {}, {
                            to: post.author.username,
                            next: location.pathname,
                        }) : null}
                        onClick={isAuthenticated(requestUser) ? null : onSendHeart}
                        asAnchor={isAuthenticated(requestUser)}
                    />
                }

                {isAuthor && post.likeable.likesCount > 0 && (
                    <MenuItem
                        label={SHOW_USERS_WHO_LIKED_THIS_POST}
                        icon="fa-thumbs-o-up"
                        link={url(urls.forumPostLikers, { topicSlug: post.topic.slug, postSlug: post.slug })}
                    />
                )}

                {isAdmin || isModerator ? (
                    <MenuItem
                        key="sticky"
                        label={post.sticky ? UNPIN_POST : PIN_POST}
                        icon="fa-thumb-tack"
                        className={cx(isAdmin && styles['PostMenu__item--admin'], isModerator && styles['PostMenu__item--moderator'])}
                        onClick={this.onChangeSticky}
                    />
                ) : null}

                {canEdit ?
                    <MenuItem
                        label={FORUM_POST_EDIT_MENU}
                        icon="fa-pencil"
                        className={cx(isAdmin && styles['PostMenu__item--admin'], isModerator && styles['PostMenu__item--moderator'], isAuthor && styles['PostMenu__item--author'])}
                        link={contest ? url(urls.forumContestEdit, {contestId: contest.id}) : isTesting ? url(urls.forumTestingEdit, {postId: post.id}) : url(urls.forumPostEdit, {postId: post.id})}
                    /> : null
                }

                {post.canBeDeleted ?
                    <MenuItem
                        label={DELETE}
                        icon="fa-trash"
                        className={cx(isAdmin && styles['PostMenu__item--admin'], isModerator && styles['PostMenu__item--moderator'], isAuthor && styles['PostMenu__item--author'])}
                        onClick={this.onDelete}
                    /> : null
                }

                {isAdmin && isTesting && (
                    <MenuItem
                        label={FORUM_POST_ADD_COMMENT_AS_ANOTHER_USER}
                        icon="fa-plus-circle"
                        className={styles['PostMenu__item--admin']}
                        link={url(urls.forumTestingCommentNew, {postSlug: post.slug, topicSlug: post.topic.slug})}
                    />
                )}

                {isAdmin && (
                    <MenuItem
                        label={FORUM_POST_ADMINCLUB_MENU}
                        icon="fa-life-ring"
                        className={styles['PostMenu__item--admin']}
                        link={adminclub_forum_post_url(post.id)}
                        asAnchor
                    />
                )}

                {hasSeoStats && (
                    <MenuItem
                        label="SEO traffic"
                        icon="fa-line-chart"
                        className={styles['PostMenu__item--admin']}
                        link={
                            url(dashUrls.dashSeoPerformace, {}, {
                                range1: DateRange1[DateRange1.Past12Weeks],
                                urls: `pageid:forum-post-${post.id}`,
                                keywords: KeywordFilterType[KeywordFilterType.NonBranded],
                            })}
                        asAnchor
                        linkTarget="_blank"
                    />
                )}
            </Menu>
        );
    }

    private onReport = () => {
        const { onReport, post } = this.props;
        onReport('forum-thread', post.id);
    };

    private onDelete = () => {
        const { onDelete, post } = this.props;
        onDelete(post.id);
    };

    private onChangeSticky = () => {
        const { post, onChangeSticky } = this.props;
        onChangeSticky(post.id, !post.sticky);
    };

}

function mapStateToProps(state: AppState, ownProps: OwnProps & RouteProps): StateProps {
    return {
        permissions: getRequestPermissions(state),
        requestUser: getRequestUser(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onReport: (entity: string, id: number) => complaintInitToggle(entity, id, true),
    onToggleMenuMore: () => menuToggle(POST_DETAIL_MENU_MORE),
    onDelete: forumDeletePost,
    onChangeSticky: postDetailPostSticky,
    onSendHeart: postSendHeart,
};

export default withRouter<OwnProps & RouteProps>(connect(mapStateToProps, mapDispatchToProps)(PostMenu));
